import React, { useEffect, useState } from "react";
import { IWidgetTemplateProps, registerCardTemplate, registerMobileCardTemplate } from "../../../common/common";
import { SelectableItem, selectUIProps, selectUIPropsForMobileTempaltes } from "../../../common/SelectableItem";
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import './ImageCardListWidget.scss'
import { WidgetWrapperWithSidebar, createDefaultPropsForWidgetWrapperWithSidebar } from "../../../common/widget-wrappers/WidgetWrapperWithSidebar";
import { TextProperty } from "../../../common/ui-props/TextProperty";
import { IImageCardProps, ImageCardWidgetProperty } from "./ImageCardProperty";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";
import { SimpleTextProperty } from "../../../common/ui-props/SimpleTextProperty";
import { TypeSelectorProperty } from "../../../common/ui-props/TypeSelectorProperty";
import classNames from "classnames";
import { hasValue, updateParentUIPropsWithDefaultWidgetUIProps } from "../../../../util";
import { SimpleNumberProperty } from "../../../common/ui-props/SimpleNumberProperty";
import { BooleanProperty } from "../../../common/ui-props/BooleanProperty";
import { wrap } from "lodash";

const ImageCardList: React.FunctionComponent<IWidgetTemplateProps> = (props) => {

    const { designer, uxpContext, params, instanceId, index } = props
    const field = props.dataKey == 'form' ? 'fields' : 'filter'

    const newImageCard: IImageCardProps = {
        image: "https://picsum.photos/id/83/600/600",
        title: 'Explore Madinah City',
        titleColor: 'black',
        subtitle: 'Look at the places you can visit',
        subtitleColor: 'black',
        titleSize: '13',
        subtitleSize: '10',
        imageSize:'cover',
        imagePosition:'center',
    }

    const defaultImageCards: IImageCardProps[] = [
        {
            image: "https://picsum.photos/id/62/600/600",
            title: 'Explore Madinah City',
            titleColor: 'black',
            subtitle: 'Look at the places you can visit',
            subtitleColor: 'black',
            titleSize: '13px',
            subtitleSize: '10px',
            imageSize:'cover',
            imagePosition:'center'
        },
        {
            image: "https://picsum.photos/id/84/600/600",
            title: 'Example Title',
            titleColor: 'white',
            subtitle: 'You can always change the subtitle',
            subtitleColor: 'white',
            titleSize: '15',
            subtitleSize: '11',
            imageSize:'cover',
            imagePosition:'center'

        }
    ]


    let uiProps = props?.uiProps || { imageCards: defaultImageCards };
    let imageCards = uiProps?.imageCards || defaultImageCards

    const parentUIProps = updateParentUIPropsWithDefaultWidgetUIProps(props.parentUIProps, uiProps, index)

    const XPRProps = createDefaultPropsForWidgetWrapperWithSidebar({
        'imageCards': ImageCardWidgetProperty(imageCards, uiProps.imageCardType?.type || 'square'),
        'cardHeight': SimpleNumberProperty('Card Height (% of screen height)', 30),
        'aspectRatio':SimpleNumberProperty('Card Aspect Ratio',1.75),
        'cardsPerView': SimpleNumberProperty('Cards Per View', 1),
        'wrapCards':BooleanProperty('Wrap cards to next line',false),   
    }, true)

    let cardHeight = Number(uiProps?.cardHeight) || 30;
    let cardsPerView = Number(uiProps?.cardsPerView) || 1;
    let wrapCards = uiProps?.wrapCards == true;
    let aspectRatio = Number(uiProps?.aspectRatio) || 1.75;

    useEffect(() => {
        console.log('Icon section widget props ', uiProps)
    }, [uiProps])

    function addNewImageCard(e: React.MouseEvent<HTMLDivElement>) {
        // e.preventDefault()
        // e.stopPropagation()

        let _uiProps = { ...uiProps || {} }
        if (!_uiProps.imageCards) _uiProps.imageCards = defaultImageCards
        _uiProps.imageCards.push(structuredClone(newImageCard))
        designer?.setMobileCardUIProps(instanceId, _uiProps, field)
    }

    function removeImageCard(removeIndex: number) {
        let _uiProps = { ...uiProps || {} }

        if (!_uiProps.imageCards) _uiProps.imageCards = defaultImageCards
        _uiProps.imageCards = _uiProps.imageCards.filter((b: any, i: number) => (i !== removeIndex))

        designer?.setMobileCardUIProps(instanceId, _uiProps, field)
    }
    const isInDesignerMode = () => props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')

    let viewHeight = 900; //todo
    let viewWidth = 450;
    return <WidgetWrapperWithSidebar
        designer={designer}
        uiProps={uiProps}
        propDef={XPRProps}
        contextData={{}}
        elementId={instanceId}
        className="wd-mobile-image-card-list-widget-wrapper"
        ignore={['imageCards']}
        enableHideHeader={true}
        showContainerPropsLast={true}
        parentUIProps={parentUIProps}
        index={index}
    >
        <div className="image-card-list-widget-container" >
            <div className={classNames("image-cards-container",{wrap:wrapCards})}>
                {
                    imageCards?.map((imageCard: IImageCardProps, i: number) => {

                        let {
                            title,
                            titleColor,
                            titleSize,
                            subtitle,
                            subtitleColor,
                            subtitleSize,
                            image,
                            backgroundColor,
                            imageSize,
                            imagePosition,

                        } = imageCard

                        let cardStyles = {
                            backgroundImage: `url('${image}')`,
                            backgroundColor,
                            backgroundSize:imageSize,
                            backgroundPosition:imagePosition,
                            backgroundRepeat:'no-repeat',
                        };
                        let cardContainerStyles:any = {};
                        if (wrapCards) {
                            let width = 100/(cardsPerView||1);

                            cardContainerStyles = {
                                // height: `${cardHeight}px`,
                                height:`${(viewWidth/(cardsPerView||1))/(aspectRatio||1)}px`,
                                width: `${100 / cardsPerView}%`
                            }
                        } else {
                            cardContainerStyles = {
                                height: `${cardHeight*viewHeight/100}px`,
                                width:`${aspectRatio*cardHeight*viewHeight/100}px`,
                                // width: `${10n0 / cardsPerView}%`
                            }
                        }

                        let titleStyles = { color: titleColor, fontSize: titleSize }
                        let subtitleStyles = { color: subtitleColor, fontSize: subtitleSize }

                        return <div key={i} style={cardContainerStyles} className={classNames("image-card-list-widget-image-card-container", 'full-width')}>
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIPropsForMobileTempaltes(uiProps, XPRProps,index, {},'wrapCards','aspectRatio', 'cardHeight', 'cardsPerView', 'imageCards')}
                                elementId={props.instanceId}
                                contextData={{ selectedIndex: i }}
                                key={i}
                            >
                                <div className="image-card-list-widget-image-card" style={cardStyles}>
                                    {isInDesignerMode() &&
                                        <div className="image-card-list-widget-image-card-remove" onClick={() => removeImageCard(i)}>
                                            <FontAwesomeIcon icon={'times'} />
                                        </div>
                                    }

                                    <div className="image-card-body">
                                        <div className="title" style={titleStyles}>{title}</div>
                                        <div className="subtitle" style={subtitleStyles}>{subtitle}</div>
                                    </div>
                                </div>
                            </SelectableItem>
                        </div>
                    })
                }
            </div>
            {isInDesignerMode() && <div className="image-card-body">
                <div className="add-new" onClick={addNewImageCard} >
                    <FontAwesomeIcon icon={['fas', 'plus']} style={{ color: '#424242' }} />
                </div>
            </div>}

        </div>
    </WidgetWrapperWithSidebar>
}

registerMobileCardTemplate({
    id: 'mobile-image-card-list',
    template: ImageCardList,
    name: 'Image card list',
    description: 'Image Card List'
})